var exports = {
  "TT": "ProfileCardUserInfo.module__userInfoContainer___QWs2ND",
  "S7": "ProfileCardUserInfo.module__nameRow___QWs2ND",
  "oo": "ProfileCardUserInfo.module__nameButton___QWs2ND",
  "uV": "ProfileCardUserInfo.module__nameButtonClickable___QWs2ND",
  "fC": "ProfileCardUserInfo.module__badgeContainer___QWs2ND",
  "NW": "ProfileCardUserInfo.module__userTagWrapper___QWs2ND",
  "Hq": "ProfileCardUserInfo.module__actionsContainer___QWs2ND",
  "Fj": "ProfileCardUserInfo.module__usernameRow___QWs2ND",
  "xO": "ProfileCardUserInfo.module__usernameButton___QWs2ND",
  "hI": "ProfileCardUserInfo.module__pronouns___QWs2ND",
  "sM": "ProfileCardUserInfo.module__srOnly___QWs2ND",
};

module.exports = exports;
